import request from '@/utils/request';
const API_URL: string = '/wy/Person'

export function propertyPerson(uesMethod: string, params: ParamsInfo | null, data: number[] | PropertyPersonInfo | null, funName: string = '') {
  return request({
    url: API_URL + funName,
    method: uesMethod,
    params,
    data
  });
}

export interface PropertyPersonInfo {
}

export interface ParamsInfo {
  wyOrganizationId?: any
  groupId?: any
  name?: string
  telephone?: string
  position?: number | string
  pageSize?: number
  pageNum?: number
  nickName?: string
  openId?: string
}
